import PropTypes from "prop-types";

export const _Quote_Component = PropTypes.shape({
  client_name: PropTypes.string,
  client_role: PropTypes.string,
  quote_content: PropTypes.string,
  quote_img: PropTypes.shape({
    alt: PropTypes.string,
    url: PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.number,
    mime_type: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    sizes: PropTypes.object,
  }),
});

export const QuotePropTypes = {
  data: PropTypes.shape({
    acf_fc_layout: PropTypes.string,
    quote_component: _Quote_Component,
  }),
};
